import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SupportComponent } from 'src/app/portal/modals/support/support.component';

@Component({
  selector: 'app-salesforce-auth-error',
  templateUrl: './salesforce-auth-error.component.html',
  standalone: false
})
export class SalesforceAuthErrorComponent {
  constructor(
    private dialog: MatDialog,
  ) {

  }
  openSupportModal(): void {
    this.dialog.open(SupportComponent, {
      height: '74rem',
    });
  }
}
